import { AxiosRequestConfig } from 'axios';
import { dbQueue } from '../Interceptor';
/**
 * PROCESS SUMMARY API
 */
export const GetProcessesByUser = async ({ Id }) => {
  let url = `ProcessSummaryAPI.ashx?action=LISTFORUSERINSTANCE&userinstanceid=${Id}`;
  const config: AxiosRequestConfig = { method: 'get', url };
  const res: any = await dbQueue({ config, url });
  return res;
};

export const GetAssignedUsersByProcess = async ({ Id }) => {
  let url = `ProcessSummaryAPI.ashx?action=GETASSIGNEDUSERS&processinstanceid=${Id}`;
  const config: AxiosRequestConfig = { method: 'get', url };
  return await dbQueue({ config, url });
};

interface FinishedOrUnfinishedType {
  Id: string;
  finishedDeal: boolean;
}

/**Get list of active deal or closed deals
 * @param {boolean} finishedDeal - true for closed finished deals / false for unfinished active deals /
 */
export const GetProcessByUserFinishedOrUnfinished = async ({
  Id,
  finishedDeal
}: FinishedOrUnfinishedType) => {
  let url = `ProcessSummaryAPI.ashx?action=LISTFORUSERINSTANCE&userinstanceid=${Id}&finished=${finishedDeal}`;
  const config: AxiosRequestConfig = { method: 'get', url };
  return await dbQueue({ config, url });
}; //END GetProcessByUserFinishedOrUnfinished

/** GET USER STATS
 * basically returns user metric number of open / closed / abandoned / won deals */
export const GetUserStats = async () => {
  let url = `ProcessSummaryAPI.ashx?action=USERSTATS`;
  const config: AxiosRequestConfig = { method: 'get', url };
  return await dbQueue({ config, url });
};

// 0 50
// 1 100
// etc
export const GetLevel12Search = async ({
  query = 'test',
  action = 'customsearch',
  offkeyset = '0',
  closed
}: {
  query?: string;
  action?: string;
  offkeyset?: string;
  closed: boolean;
}) => {
  let url = `ProcessSummaryAPI.ashx?action=${action}&q=${query}&offset=${offkeyset}&closed=${closed}`;
  const config: AxiosRequestConfig = { method: 'get', url };
  return await dbQueue({ config, url });
};

/**
 * PROCESS SUMMARY API - NEW ENDPOINTS
 */
interface PagedListParams {
  pagesize?: number;
  page?: number;
  finished?: boolean;
  q?: string;
}

/**
 * Get paginated list of processes
 * @param {number} pagesize - number of records to be returned (optional)
 * @param {number} page - the current page to be returned (optional)
 * @param {boolean} finished - whether to return closed or open processes (optional)
 * @returns A CustomProcessSummary List
 * @notes Returns only the user's processes if they are below level 10 and domain processes if they are above level 10
 */
export const GetPagedProcessList = async ({
  pagesize,
  page,
  finished,
  q
}: PagedListParams = {}) => {
  let url = `ProcessSummaryAPI.ashx?action=PAGEDLIST`;

  const params = new URLSearchParams();
  if (pagesize !== undefined) params.append('pagesize', pagesize.toString());
  if (page !== undefined) params.append('page', page.toString());
  if (finished !== undefined) params.append('finished', finished.toString());
  if (q !== undefined) params.append('q', q.toString());

  if (params.toString()) {
    url += `&${params.toString()}`;
  }

  const config: AxiosRequestConfig = { method: 'get', url };
  return await dbQueue({ config, url });
};

interface CustomSearchParams {
  q: string;
  offset: string | number;
  closed?: boolean;
}

/**
 * Custom search for processes (Level 12+ users only)
 * @param {string} q - search term (process instance id or forward matching string)
 * @param {string|number} offset - zero indexed page number
 * @param {boolean} closed - optional boolean, defaults to false
 * @returns A CustomProcessSummary List
 * @notes Only available to level 12 users and above. Page size is 50 records.
 * Data is filtered by brandlist for logged in user's instance unless user is level 15.
 */
export const GetCustomSearchProcesses = async ({
  q,
  offset,
  closed
}: CustomSearchParams) => {
  let url = `ProcessSummaryAPI.ashx?action=CUSTOMSEARCH&q=${encodeURIComponent(
    q
  )}&offset=${offset}`;

  if (closed !== undefined) {
    url += `&closed=${closed}`;
  }

  const config: AxiosRequestConfig = { method: 'get', url };
  return await dbQueue({ config, url });
};

interface PagedListByUserParams {
  userinstanceid: number;
  pagesize?: number;
  page?: number;
  finished?: boolean;
  q?: string;
}

/**
 * Get paginated list of processes for a specific user
 * @param {number} userinstanceid - the user instance id to filter by (required)
 * @param {number} pagesize - number of records to be returned (optional)
 * @param {number} page - the current page to be returned (optional)
 * @param {boolean} finished - whether to return closed or open processes (optional)
 * @param {string} q - search query (optional)
 * @returns A CustomProcessSummary List for the specified user
 */
export const GetPagedProcessListByUser = async ({
  userinstanceid,
  pagesize,
  page,
  finished,
  q
}: PagedListByUserParams) => {
  let url = `ProcessSummaryAPI.ashx?action=PAGEDLIST&userinstanceid=${userinstanceid}`;

  const params = new URLSearchParams();
  if (pagesize !== undefined) params.append('pagesize', pagesize.toString());
  if (page !== undefined) params.append('page', page.toString());
  if (finished !== undefined) params.append('finished', finished.toString());
  if (q !== undefined) params.append('q', q.toString());

  if (params.toString()) {
    url += `&${params.toString()}`;
  }

  const config: AxiosRequestConfig = { method: 'get', url };
  return await dbQueue({ config, url });
};
